import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'

import {
    SettingFilters,
    SettingsGetListResponseT,
    SettingsGetNotificationItResponseT,
    SettingsGetNotificationsItListResponseT,
    SettingsGetNotificationsListResponseT,
    SettingsGetWabaTemplatesParams,
    SettingsGetWabaTemplatesResponse,
    SettingsWabaTemplatesCreatePayload,
    SettingsWabaTemplatesGetLanguagesResponse,
    SettingsWabaTemplatesUpdatePayload,
    AttachWabaTemplatesPayload,
    SettingsWabaTemplatesGetStatusesResponse,
    SettingsWabaTemplatesGetCategoriesResponse,
    SettingsGetWabaTemplateCategoriesResponseT,
} from '../types/settings.types'

export class SettingsRepository {
    getList(filters: SettingFilters): Promise<AxiosResponse<SettingsGetListResponseT>> {
        return http.get('/cabinet/api/settings', { params: filters })
    }

    udpateSettingState(setting_id: number, value: string): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/settings/${setting_id}`, { value })
    }

    getNotificationsList(
        filters: SettingFilters
    ): Promise<AxiosResponse<SettingsGetNotificationsListResponseT>> {
        return http.get('/notification/api/settings', { params: filters })
    }

    updateNotificationSettingState(
        setting_id: number,
        is_active: boolean
    ): Promise<AxiosResponse<void>> {
        return http.put(`/notification/api/settings/${setting_id}`, { is_active })
    }

    getNotificationIt(id: number): Promise<AxiosResponse<SettingsGetNotificationItResponseT>> {
        return http.get(`/notification/api/company-settings/${id}`, { params: { id } })
    }

    editTemplateNotificationIt(id: number, body: string): Promise<AxiosResponse<void>> {
        return http.put(`/notification/api/templates/${id}`, { id, body })
    }

    editCompaniesNotificationIt(
        settingsId: number,
        companyIds: number[]
    ): Promise<AxiosResponse<void>> {
        return http.put(`/notification/api/company-settings/${settingsId}/companies`, {
            settingsId,
            companyIds,
        })
    }

    getNotificationsItList(
        page: number,
        limit: number
    ): Promise<AxiosResponse<SettingsGetNotificationsItListResponseT>> {
        return http.get('/notification/api/company-settings', { params: { page, limit } })
    }

    enableNotificationIt(settingsId: number): Promise<AxiosResponse<void>> {
        return http.put(`/notification/api/company-settings/${settingsId}/activate`, { settingsId })
    }

    disableNotificationIt(settingsId: number): Promise<AxiosResponse<void>> {
        return http.put(`/notification/api/company-settings/${settingsId}/deactivate`, {
            settingsId,
        })
    }

    getWabaTemplates(params: SettingsGetWabaTemplatesParams): Promise<AxiosResponse<SettingsGetWabaTemplatesResponse>> {
        return http.get('/notification/api/whatsapp/templates', { params })
    }

    wabaTemplatesGetLanguages(): Promise<AxiosResponse<SettingsWabaTemplatesGetLanguagesResponse>> {
        return http.get('/notification/api/whatsapp/templates/languages')
    }

    wabaTemplatesGetStatuses(): Promise<AxiosResponse<SettingsWabaTemplatesGetStatusesResponse>> {
        return http.get('/notification/api/whatsapp/templates/statuses')
    }

    wabaTemplatesGetCategories(): Promise<AxiosResponse<SettingsWabaTemplatesGetCategoriesResponse>> {
        return http.get('/notification/api/whatsapp/templates/categories')
    }

    createWabaTemplate(payload: SettingsWabaTemplatesCreatePayload): Promise<AxiosResponse<void>> {
        return http.post('/notification/api/whatsapp/templates', payload)
    }

    updateWabaTemplate(id: number, payload: SettingsWabaTemplatesUpdatePayload): Promise<AxiosResponse<void>> {
        return http.put(`/notification/api/whatsapp/templates/${id}`, payload)
    }

    deleteWabaTemplate(id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/notification/api/whatsapp/templates/${id}`)
    }

    attachWabaTemplates(settingsId: number, payload: AttachWabaTemplatesPayload): Promise<AxiosResponse<void>> {
        return http.put(`/notification/api/company-settings/${settingsId}/whatsapp-templates`, payload)
    }

    syncWabaTemplate(templateId: number): Promise<AxiosResponse<void>> {
        return http.post(`/notification/api/whatsapp/templates/${templateId}/sync-status`, {})
    }

    syncWabaTemplates(): Promise<AxiosResponse<void>> {
        return http.post('/notification/api/whatsapp/templates/sync', {})
    }

    getWabaTemplateCategories(): Promise<AxiosResponse<SettingsGetWabaTemplateCategoriesResponseT>> {
        return http.get('/notification/api/whatsapp/templates/categories', {
            params: { page: 1, limit: 9999 }
        })
    }
}
